import * as React from 'react';
import styled from 'react-emotion';
import { RegionGroup, RegionWrapper } from './Region';
import { CommitButton, CancelButton } from './ChannelSelectorButtons';
import { LangCurrWrapper, SelectorBody, Title } from './ChannelSelector';
import { CheckboxWrapper } from '../Checkbox/CheckboxGroup';
const SelectorWrapper = styled('div') `
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  border: 1px solid #e8e8e8;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.07);

  ${RegionGroup} {
    max-width: calc(20% - 2rem);
    margin: 0 1rem;
    min-width: 15rem;
    flex-grow: 1;
  }

  ${RegionWrapper} {
    display: flex;
    margin: 0 -1rem;
  }

  ${Title} {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 1rem;
    padding-bottom: 3rem;
    font-weight: 600;
    text-align: left;
  }

  ${CommitButton}, ${CancelButton} {
    width: 20%;
    max-width: 15rem;
    margin-left: auto;
  }

  ${CancelButton} {
    border-color: #cccccc;
  }

  ${LangCurrWrapper} {
    display: flex;
    padding: 1.5rem;
    margin-bottom: 1rem;
  }

  ${CheckboxWrapper} {
    margin-right: 2rem;
    width: calc(20% + 1rem);
    strong {
      font-weight: 600;
    }
  }
  ${SelectorBody} {
    padding: 1rem;
  }
`;
const LargeSelector = ({ children }) => {
    return React.createElement(SelectorWrapper, null, children);
};
export default LargeSelector;
//# sourceMappingURL=LargeSelector.js.map